import "./CommentsCard.scss";
export default function CommentsCard({ name, date, comment }) {
  return (
    <li className="comment">
      <img
        className="comment__img"
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        alt="avatar"
      />
      <div className="comment__section">
        <div className="comment__title">
          <p className="comment__name">{name}</p>
          <p className="comment__date">
            {new Date(date).toLocaleDateString("en-US")}
          </p>
        </div>
        <p className="comment__body">{comment}</p>
      </div>
    </li>
  );
}
